<template>
  <div>
    <div class="password">
      <div>
        <div class="title">新密码</div>
        <div>
          <input
            :type="form.password_eye == true ? 'text' : 'password'"
            placeholder="填写密码"
            v-model="form.password"
            maxlength="16"
          />
          <i
            class="el-icon-lock"
            v-show="!form.password_eye"
            @click="form.password_eye = !form.password_eye"
          ></i>
          <i
            class="el-icon-unlock"
            v-show="form.password_eye"
            @click="form.password_eye = !form.password_eye"
          ></i>
        </div>
        <div class="title">确认密码</div>
        <div>
          <input
            :type="form.password_eye_reset == true ? 'text' : 'password'"
            placeholder="确认密码"
            v-model="form.newPassword"
            maxlength="16"
          />
          <i
            class="el-icon-lock"
            v-show="!form.password_eye_reset"
            @click="form.password_eye_reset = !form.password_eye_reset"
          ></i>
          <i
            class="el-icon-unlock"
            v-show="form.password_eye_reset"
            @click="form.password_eye_reset = !form.password_eye_reset"
          ></i>
        </div>
      </div>
      <div class="explain">密码必须是8-16位的英文字母、数字、字符组合</div>
      <div class="submit">
        <div class="save" @click="handleSubmit()">确定</div>
        <div class="cancel" @click="handleCancel()">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { PassWordChange } from "@/api/login/index";
export default {
  data() {
    return {
      form: {
        password_eye: false,
        password_eye_reset: false,
        password: "",
        newPassword: "",
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleSubmit() {
      var re = /^(?=.*[a-z])(?=.*\d)[^]{8,16}$/;
      if (!re.test(this.form.password)) {
        this.$message.error(" 密码必须是8-16位的英文字母、数字、字符组合");
        return;
      }
      if (this.form.password != this.form.newPassword) {
        this.$message.error("两次密码不一样");
        return;
      }
      PassWordChange(this.form).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
          sessionStorage.clear();
          this.$emit("logout", false);
          this.$eventBus.emit("logout");
          this.$router.push({ path: "/" });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 取消
    handleCancel() {
      (this.form.password = ""), (this.form.newPassword = "");
    },
  },
};
</script>

<style scoped>
.title {
  color: #212121;
  font-size: 1rem;
  margin-top: 15px;
}

.password {
  margin-left: 40px;
}

.explain {
  margin-top: 20px;
  color: #5c5c5c;
  font-size: 0.85rem;
}

.submit {
  width: 300px;
  height: 32px;
  margin-top: 30px;
  cursor: pointer;
  font-size: 0.85rem;
  color: #fff;
  display: flex;
  align-items: center;
}

.save {
  width: 100px;
  background: #2c83f6;
  border-radius: 6px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  cursor: pointer;
  font-size: 0.85rem;
  margin-right: 15px;
}

.cancel {
  width: 100px;
  border-radius: 6px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2c83f6;
  cursor: pointer;
  font-size: 0.85rem;
  border: 1px solid #2c83f6;
}

input {
  margin-top: 10px;
  width: 250px;
  height: 30px;
  line-height: 30px;
  padding-left: 15px;
  border: 1px solid #d5d5d5;
  outline: 0;
}
input::placeholder {
  color: #969696;
}
.el-icon-lock {
  cursor: pointer;
  position: relative;
  right: 26px;
}
.el-icon-unlock {
  cursor: pointer;
  position: relative;
  right: 26px;
}
</style>